<template>
    <v-container fluid>
        <v-row align="center" class="px-4 pt-2 pb-0" justify="center" :style="{background: $vuetify.theme.themes.light.sheet}">
            <v-col sm="12" class="text-subtitle-1 font-weight-bold px-4 py-0" style="margin: 0; padding: 4px">
                Stock Indexes - 52W range
            </v-col>
        </v-row>

        <v-row align="center" class="px-4 py-0" justify="center" :style="{background: $vuetify.theme.themes.light.sheet}">
            <v-col sm="12" md="4" v-for="item in benchmarks" :key="item.name" style="margin: 0; padding: 4px">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col md="4" style="margin: auto; padding: 6px">
                                <span class="font-weight-bold">{{ item.instrumentName }}</span><br/>
                                <span class="font-weight-bold">{{ item.lastClosePrice | number }}</span>

                                <v-spacer></v-spacer>

                                <span v-if="item.performance > 0" class="font-weight-bold" :style="{color: $vuetify.theme.themes.light.positive}">{{ item.performance | percentage }}</span>
                                <span v-if="item.performance === 0 || item.performance == null" class="font-weight-bold">{{ item.performance | percentage }}</span>
                                <span v-if="item.performance < 0" class="font-weight-bold" :style="{color: $vuetify.theme.themes.light.negative}">{{ item.performance | percentage }}</span>
                            </v-col>
                            <v-col md="8" style="margin: auto; padding: 6px">
                                <TheSparkline
                                    width="250"
                                    height="50"
                                    :values="item.closures.map((v) => v - item.closures[0])"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row align="center" class="px-4 py-0" justify="center" :style="{background: $vuetify.theme.themes.light.sheet}">
            <v-col sm="12" class="text-caption text-right px-4" style="margin: 0; padding: 4px">
                Valuation date: <strong>{{ previousBusinessDay() }}</strong>
            </v-col>
        </v-row>

        <v-row align="center" class="px-4 pt-2" justify="center" :style="{background: $vuetify.theme.themes.light.sheet}">
            <v-col class="text-center" md="3">
                <v-img src="2112312.png"/>
            </v-col>

            <v-col class="text-center" md="12">
                <h2 class="mb-4 display-1 font-weight-bold" v-html="$t('home.title')"/>

                <p class="mb-4 font-weight-medium">
                    {{ $t('home.text') }}
                </p>

                <v-btn @click="$router.push({ path: '/register' })" class="mx-4 my-4" color="secondary">{{ $t('home.button.label') }}</v-btn>

                <v-btn @click="openDialog" color="secondary" outlined>See how it works!</v-btn>
            </v-col>
        </v-row>

        <v-row align="center" class="px-2 pt-2" justify="center" :style="{background: $vuetify.theme.themes.light.sheet}">
            <v-col sm="6" class="text-subtitle-1 font-weight-bold px-4 py-0">
                Popular Stocks
            </v-col>
        </v-row>

        <v-row align="center" class="" justify="center" :style="{background: $vuetify.theme.themes.light.sheet}">
            <v-col class="" md="6" style="margin: 0; padding: 4px">
                <v-card>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Price</th>
                                <th>Change 1M</th>
                                <th>Positions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                class="row-pointer"
                                v-for="item in instruments"
                                :key="item.name"
                                @click="readInstrument(item.id)"
                            >
                                <td><strong>{{ item.instrumentName }}</strong></td>
                                <td><strong>{{ item.lastClosePrice | number2 }} {{ item.currency }}</strong></td>
                                <td>
                                    <span v-if="item.performance > 0" class="font-weight-bold" :style="{color: $vuetify.theme.themes.light.positive}">{{ item.performance | percentage }}</span>
                                    <span v-if="item.performance === 0 || item.performance == null" class="font-weight-bold">{{ item.performance | percentage }}</span>
                                    <span v-if="item.performance < 0" class="font-weight-bold" :style="{color: $vuetify.theme.themes.light.negative}">{{ item.performance | percentage }}</span>
                                </td>
                                <td><strong>{{ item.openPositions }}</strong> open positions</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>

                <v-row>
                    <v-spacer/>
                    <v-col class="text-caption text-right mt-2 mr-2">
                        Valuation date: <strong>{{ previousBusinessDay() }}</strong>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog"
            :max-width="$vuetify.breakpoint.mobile ? 360 : 680"
        >
            <v-card>
                <v-card-title></v-card-title>

                <v-card-text>
                    <vimeo-player video-id="850043703" :options="options" :player-width="$vuetify.breakpoint.mobile ? 300 : 640"/>
                </v-card-text>

                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import TheSparkline from '@/components/TheSparkline.vue'

import InstrumentService from "@/services/InstrumentService"

import moment from 'moment-business-days'

export default {
    components: {TheSparkline},
    data() {
        return {
            dialog: false,
            options: {
                byline: false,
                portrait: false,
                title: false,
            },
            benchmarks: [],
            instruments: []
        }
    },
    methods: {
        openDialog() {
            this.dialog = true
        },
        previousBusinessDay() {
            return moment().businessSubtract(1).format('YYYY-MM-DD')
        },
        readInstrument(id) {
            this.$router.push({path: '/instruments/' + id})
        },
    },
    mounted() {
        InstrumentService.readAllHotBenchmarks(0, 10, 'instrumentName', false)
            .then(response => {
                this.benchmarks = response.data.content
            })

        InstrumentService.readAllHotInstruments(0, 10, 'openPositions', true)
            .then(response => {
                this.instruments = response.data.content
            })
    }
}
</script>

<style lang="css" scoped>
.row-pointer {
    cursor: pointer;
}
</style>
